// // // firebase.js
// // import { initializeApp } from "firebase/app";
// // import { getFirestore } from "firebase/firestore";
// // import { getDatabase } from "firebase/database";
// // import { getMessaging, getToken, onMessage } from "firebase/messaging";

// // // ✅ Firebase config
// // const firebaseConfig = {
// //   apiKey: "AIzaSyAAob8xPKtuHRbTeyACOYl_jnSGkr5U1lI",
// //   authDomain: "volume-tv-270e8.firebaseapp.com",
// //   projectId: "volume-tv-270e8",
// //   storageBucket: "volume-tv-270e8.appspot.com", // 👈 corrected
// //   messagingSenderId: "848676312814",
// //   appId: "1:848676312814:web:ca9bb9c0aaea424cbb45ff",
// //   measurementId: "G-CETRNF7LJD"
// // };

// // // ✅ Init app
// // const app = initializeApp(firebaseConfig);

// // // ✅ Firestore (messages, chats, groups, history)
// // export const db = getFirestore(app);

// // // ✅ Realtime DB (presence, typing, lastSeen)
// // export const rtdb = getDatabase(app);
// // export const messaging = getMessaging(app);

// // if ("serviceWorker" in navigator) {
// //   navigator.serviceWorker
// //     .register("/volumetv/firebase-messaging-sw.js")
// //     .then((registration) => {
// //       getToken(messaging, {
// //         serviceWorkerRegistration: registration,
// //         vapidKey:
// //           "BOU7hdQgLMfKMNENWVd5pQgopbu_jW6K83kgGzquuClXKV5hlqR6X90ZyuvOcs7hQ-iU3KsdTprO64R36mB8uDo",
// //       })
// //         .then((currentToken) => {
// //           if (currentToken) {
// //             console.log("Current token:", currentToken);
// //             localStorage.setItem("device_token", currentToken);
// //           }
// //         })
// //         .catch((err) => {
// //           localStorage.setItem("device_token", "currentToken");
// //         });

// //       onMessage(messaging, (payload) => {
// //         console.log("Message received:", payload);

// //       });
// //     })
// //     .catch((error) => {
// //       console.error("Service Worker registration failed:", error);
// //     });
// // }

// // export {

// //   getToken,
// //   onMessage,
// // };

// // firebase.js
// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getDatabase, ref, set, onDisconnect, serverTimestamp } from "firebase/database"; // ✅ Added RTDB functions
// import { getAuth, onAuthStateChanged } from "firebase/auth"; // ✅ Added Auth
// import { getMessaging, getToken, onMessage } from "firebase/messaging";

// // ✅ Firebase config
// const firebaseConfig = {
//   apiKey: "AIzaSyAAob8xPKtuHRbTeyACOYl_jnSGkr5U1lI",
//   authDomain: "volume-tv-270e8.firebaseapp.com",
//   databaseURL: "https://volume-tv-270e8-default-rtdb.firebaseio.com", // ✅ RTDB URL important
//   projectId: "volume-tv-270e8",
//   storageBucket: "volume-tv-270e8.appspot.com",
//   messagingSenderId: "848676312814",
//   appId: "1:848676312814:web:ca9bb9c0aaea424cbb45ff",
//   measurementId: "G-CETRNF7LJD"
// };

// // ✅ Init app
// const app = initializeApp(firebaseConfig);

// // ✅ Services
// export const db = getFirestore(app);
// export const rtdb = getDatabase(app);
// export const auth = getAuth(app); // ✅ Auth service export karna
// export const messaging = getMessaging(app);

// // ✅ Online Status Management Functions
// export const setupUserStatus = (user) => {
//   if (!user) return;

//   const userStatusRef = ref(rtdb, 'status/' + user.uid);

//   // Online status set karein
//   set(userStatusRef, {
//     online: true,
//     lastSeen: serverTimestamp(),
//     email: user.email,
//     name: user.displayName || user.email.split('@')[0],
//     userId: user.uid
//   }).catch(error => {
//     console.error('Online status set error:', error);
//   });

//   // Agar connection lost ho to offline mark karein
//   onDisconnect(userStatusRef).set({
//     online: false,
//     lastSeen: serverTimestamp(),
//     email: user.email,
//     name: user.displayName || user.email.split('@')[0],
//     userId: user.uid
//   });
// };

// // ✅ Auth State Listener for Online Status
// export const initAuthListener = () => {
//   onAuthStateChanged(auth, (user) => {
//     if (user) {
//       console.log('User logged in, setting online status');
//       setupUserStatus(user);
//     } else {
//       console.log('User logged out');
//     }
//   });
// };

// // ✅ Service Worker setup (aapka existing code)
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/volumetv/firebase-messaging-sw.js")
//     .then((registration) => {
//       getToken(messaging, {
//         serviceWorkerRegistration: registration,
//         vapidKey: "BOU7hdQgLMfKMNENWVd5pQgopbu_jW6K83kgGzquuClXKV5hlqR6X90ZyuvOcs7hQ-iU3KsdTprO64R36mB8uDo",
//       })
//         .then((currentToken) => {
//           if (currentToken) {
//             console.log("Current token:", currentToken);
//             localStorage.setItem("device_token", currentToken);
//           }
//         })
//         .catch((err) => {
//           localStorage.setItem("device_token", "currentToken");
//         });

//       onMessage(messaging, (payload) => {
//         console.log("Message received:", payload);
//       });
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }

// export { getToken, onMessage };

// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getDatabase, ref, set, update, onDisconnect, serverTimestamp , push, onValue, remove } from "firebase/database";
// import { getAuth } from "firebase/auth";

// import { getMessaging, getToken, onMessage } from "firebase/messaging";

// // ✅ Firebase config
// const firebaseConfig = {
//   apiKey: "AIzaSyAAob8xPKtuHRbTeyACOYl_jnSGkr5U1lI",
//   authDomain: "volume-tv-270e8.firebaseapp.com",
//   databaseURL: "https://volume-tv-270e8-default-rtdb.firebaseio.com",
//   projectId: "volume-tv-270e8",
//   storageBucket: "volume-tv-270e8.appspot.com",
//   messagingSenderId: "848676312814",
//   appId: "1:848676312814:web:ca9bb9c0aaea424cbb45ff",
//   measurementId: "G-CETRNF7LJD",
// };

// // ✅ Init app
// const app = initializeApp(firebaseConfig);

// // ✅ Services
// export const db = getFirestore(app);
// export const rtdb = getDatabase(app);
// export const auth = getAuth(app);
// export const messaging = getMessaging(app);

// // ✅ Online Status Management Functions
// export const setupUserStatus = (user) => {
//   if (!user || !user.uid) return;

//   const userStatusRef = ref(rtdb, "status/" + user.uid);

//   // Online status set karein
//   set(userStatusRef, {
//     online: true,
//     lastSeen: serverTimestamp(),
//     email: user.email,
//     name: user.displayName || user.email?.split("@")[0] || "Guest",
//     userId: user.uid,
//   }).catch((error) => {
//     console.error("Online status set error:", error);
//   });

//   // Disconnect hone par offline mark karein
//   onDisconnect(userStatusRef).set({
//     online: false,
//     lastSeen: serverTimestamp(),
//     email: user.email,
//     name: user.displayName || user.email?.split("@")[0] || "Guest",
//     userId: user.uid,
//   });
// };

// export const setupUserStatusMultiTab = (user) => {
//   if (!user) return;

//   const userConnectionsRef = ref(rtdb, "connections/" + user.uid);
//   const lastOnlineRef = ref(rtdb, "status/" + user.uid);

//   // Unique connection ID for this tab
//   const myConnectionRef = push(userConnectionsRef);

//   // Mark this tab as connected
//   set(myConnectionRef, true);

//   // Remove this connection when tab closes
//   onDisconnect(myConnectionRef).remove();

//   // Update user status whenever connections change
//   onValue(userConnectionsRef, (snapshot) => {
//     const isOnline = snapshot.exists(); // true if any tab/device connected
//     set(lastOnlineRef, {
//       online: isOnline,
//       lastSeen: serverTimestamp(),
//       email: user.email,
//       name: user.displayName || user.email.split("@")[0],
//       userId: user.uid,
//     });
//   });
// };

// // ✅ Service Worker setup
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/volumetv/firebase-messaging-sw.js")
//     .then((registration) => {
//       getToken(messaging, {
//         serviceWorkerRegistration: registration,
//         vapidKey: "BOU7hdQgLMfKMNENWVd5pQgopbu_jW6K83kgGzquuClXKV5hlqR6X90ZyuvOcs7hQ-iU3KsdTprO64R36mB8uDo",
//       })
//         .then((currentToken) => {
//           if (currentToken) {
//             console.log("Current token:", currentToken);
//             localStorage.setItem("device_token", currentToken);
//           }
//         })
//         .catch(() => {
//           localStorage.setItem("device_token", "currentToken");
//         });

//       onMessage(messaging, (payload) => {
//         console.log("Message received:", payload);
//       });
//     })
//     .catch((error) => {
//       console.error("Service Worker registration failed:", error);
//     });
// }

// export { getToken, onMessage };

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import {
  getDatabase,
  ref,
  set,
  update,
  onDisconnect,
  serverTimestamp,
  push,
  onValue,
  remove,
} from "firebase/database";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// ✅ Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAAob8xPKtuHRbTeyACOYl_jnSGkr5U1lI",
  authDomain: "volume-tv-270e8.firebaseapp.com",
  databaseURL: "https://volume-tv-270e8-default-rtdb.firebaseio.com",
  projectId: "volume-tv-270e8",
  storageBucket: "volume-tv-270e8.appspot.com",
  messagingSenderId: "848676312814",
  appId: "1:848676312814:web:ca9bb9c0aaea424cbb45ff",
  measurementId: "G-CETRNF7LJD",
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Services
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
export const messaging = getMessaging(app);

// ✅ Online Status (Single Tab)
export const setupUserStatus = (user) => {
  if (!user || !user.id) return; // use backend user id instead of Firebase uid

  const userStatusRef = ref(rtdb, "status/" + user.id);

  // Mark online
  set(userStatusRef, {
    online: true,
    lastSeen: serverTimestamp(),
    email: user.email,
    name: user.name || user.email?.split("@")[0] || "Guest",
    userId: user.id,
  }).catch((error) => {
    console.error("Online status set error:", error);
  });

  // Mark offline on disconnect
  onDisconnect(userStatusRef).set({
    online: false,
    lastSeen: serverTimestamp(),
    email: user.email,
    name: user.name || user.email?.split("@")[0] || "Guest",
    userId: user.id,
  });
};

// ✅ Online Status (Multi-Tab Support)
export const setupUserStatusMultiTab = (user) => {
  if (!user || !user.id) return;

  const userConnectionsRef = ref(rtdb, "connections/" + user.id);
  const lastOnlineRef = ref(rtdb, "status/" + user.id);

  const myConnectionRef = push(userConnectionsRef);
  set(myConnectionRef, true);

  onDisconnect(myConnectionRef).remove();

  onValue(userConnectionsRef, (snapshot) => {
    const isOnline = snapshot.exists();
    set(lastOnlineRef, {
      online: isOnline,
      lastSeen: serverTimestamp(),
      email: user.email,
      name: user.name || user.email.split("@")[0],
      userId: user.id,
    });
  });
};

// ✅ FCM Service Worker Setup
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("firebase-messaging-sw.js")
    .then((registration) => {
      getToken(messaging, {
        serviceWorkerRegistration: registration,
        vapidKey:
          "BOU7hdQgLMfKMNENWVd5pQgopbu_jW6K83kgGzquuClXKV5hlqR6X90ZyuvOcs7hQ-iU3KsdTprO64R36mB8uDo",
      })
        .then((currentToken) => {
          if (currentToken) {
            console.log("Current token:", currentToken);
            localStorage.setItem("device_token", currentToken);
          }
        })
        .catch(() => {
          localStorage.setItem("device_token", "currentToken");
        });

      onMessage(messaging, (payload) => {
        console.log("Message received:", payload);
      });
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

export { getToken, onMessage };
